const getDefaultState = () => ({
    currentProfileTab: null,
});

const state = getDefaultState();

const getters = {

    getterProfileTab(state){
        return state.currentProfileTab
    }

};

const mutations = {

    resetProfileTab(state){
        Object.assign(state, getDefaultState())
    },

    setterProfileTab(state, data){
        state.currentProfileTab = data
    }

};


export default {
    state,
    getters,
    mutations
}
